export default function WhySection() {
  return (
    <section className="py-16 md:py-24 bg-accent-50/60">
      <div className="px-6 md:px-10 max-w-[1440px] mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm font-medium mb-4">
            Why Kakobuy Sheet
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            The Most Organized
            <br />
            Shopping Database Online
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-14">
          <div>
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
              <i className="ri-database-2-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-2">Curated Product Lists</h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Every item in the Kakobuy spreadsheet is hand-picked and verified, saving you hours of manual research across scattered sources.
            </p>
          </div>
          <div>
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
              <i className="ri-refresh-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-2">Weekly Updates</h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              The spreadsheet is refreshed every week with new trending products, so you always have access to the latest finds and popular items.
            </p>
          </div>
          <div>
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-2">Safe Shopping Guides</h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              We provide detailed safety tips and verification methods so you can shop with confidence and avoid unreliable sellers.
            </p>
          </div>
          <div>
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
              <i className="ri-group-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-2">Community Verified</h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Thousands of smart shoppers rely on Kakobuy spreadsheet resources to discover quality products and make informed purchasing decisions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          <div className="text-center">
            <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600">500+</p>
            <p className="text-foreground-600 text-sm mt-2">Finds</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600">14</p>
            <p className="text-foreground-600 text-sm mt-2">Categories</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600">Weekly</p>
            <p className="text-foreground-600 text-sm mt-2">Updates</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600">100%</p>
            <p className="text-foreground-600 text-sm mt-2">Free Access</p>
          </div>
        </div>
      </div>
    </section>
  );
}